import { Injectable } from '@angular/core';
import * as Rx from "rxjs";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class HeaderService {

  public title = new Rx.BehaviorSubject('Admin Dashboard');

  constructor(public router: Router) { }

  setTitle(title) {
    this.title.next(title);
  }
  
}
